import React from 'react'
import { DocumentTextIcon } from '@heroicons/react/24/outline'

export const StartCenterInfo: React.FC = () => {
  return (
    <main className="min-h-screen bg-[#EDE6DE] px-4 py-12 md:px-8 lg:px-16">
      <div className="max-w-[1400px] mx-auto">
        <h1 className="text-4xl md:text-5xl font-serif text-[#3C2416] mb-12">
          Start a Clinical Sickle Cell Disease Center
        </h1>

        <section className="flex flex-col xl:flex-row gap-8">
          <div className="xl:w-1/2">
            <div className="prose prose-lg max-w-none">
              <h2 className="text-xl text-[#A6410A] font-medium mb-4">
                Overview
              </h2>
              <p className="text-[#3C2416]">
                The{' '}
                <a
                  href="https://www.hematology.org/"
                  className="text-[#A6410A] hover:text-[#894d35] underline"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  American Society of Hematology (ASH)
                </a>{' '}
                hosted a{' '}
                <a
                  href="https://www.hematology.org/meetings/sickle-cell-disease-workshop"
                  className="text-[#A6410A] hover:text-[#894d35] underline"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Sickle Cell Disease Centers Workshop
                </a>{' '}
                where they introduced the components needed to start a clinical
                center focused on the needs of those living with sickle cell
                disease. The workshop included an introduction to the components
                of such centers, the process for developing a business plan and
                advocating to stakeholders, the ins and outs of operations, and
                approaches to measuring impact and improving the quality of care
                in these centers.
              </p>
            </div>
          </div>

          <div className="xl:w-1/2">
            <div className="bg-white rounded-xl shadow-md overflow-hidden">
              <div className="flex justify-between items-center p-6">
                <div className="flex items-center gap-2">
                  <div className="flex items-center justify-center w-8 h-8 text-[#A6410A]">
                    <DocumentTextIcon className="w-6 h-6" />
                  </div>
                  <h2 className="text-xl text-[#A6410A] font-medium">
                    Educational Resources
                  </h2>
                </div>
              </div>

              <div className="px-6 pb-6">
                <p className="text-[#3C2416] mb-4">
                  In collaboration with{' '}
                  <a
                    href="https://www.francefoundation.com/"
                    className="text-[#A6410A] hover:text-[#894d35] underline"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    The France Foundation
                  </a>
                  , ASH has developed a series of <strong>free</strong>{' '}
                  <a
                    href="https://academy.hematology.org/local/catalog/view/product.php?productid=1167"
                    className="text-[#A6410A] hover:text-[#894d35] underline"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    15-minute modules
                  </a>{' '}
                  to address clinical practice topics related to Sickle Cell
                  Disease. These modules are intended as tools to aid health
                  care providers in their development toward becoming adult
                  Sickle Cell Disease centers. Continuing Medical Education
                  (CME) credit is available for these modules.
                </p>

                <div className="mt-6">
                  <h3 className="text-lg font-medium text-[#3C2416] mb-3">
                    Topics include:
                  </h3>
                  <ul className="space-y-3 text-[#3C2416] font-medium">
                    {[
                      'SCD Center Essentials: Models and Teams',
                      'Managing Together - The Clinician as Change Agents',
                      'Working with Community-based Organizations',
                      'Bias and Sickle Cell Disease',
                      'The Changing Therapeutic Landscape of SCD',
                      'The Financial Case for SCD Centers',
                      'Creating an Institutional Approach to Pain'
                    ].map((topic, index) => (
                      <li key={index} className="flex pl-4 items-start">
                        <span className="mr-2 mt-[0.5rem] h-2 w-2 flex-shrink-0 rounded-full bg-[#A6410A]" />
                        <span>{topic}</span>
                      </li>
                    ))}
                  </ul>

                  <p className="mt-6 text-[#3C2416]">
                    Creating a login to the ASH website is required to access
                    the courses and is <strong>free</strong>.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </main>
  )
}
